import {
  DELETE_COLUMN,
  RESET_CONDITION_MODAL,
  SET_COLUMN_NAME_VALUE,
  SET_COLUMN_SCHEME,
  SET_CONDITION_VARIABLES,
  SET_CURRENT_SORTED_VALUE,
  SET_CURSOR_POSITION,
  SET_FUNCTION_VALUE,
  SET_NODE_LIST,
  SET_SHOW_DROPDOWN,
  SET_TREE,
} from "store/constans";
import { valueTypes } from "utils/builder/ResultClasses";
import { FormulaTree } from "utils/services";
import { functionParserService } from "utils/services/functionParser.service";
import { v4 } from "uuid";

export const setConditionVariablesAC = (headers, types) => {
  const conditionVariables = headers?.map((item, index) => {
    return {
      name: item,
      conditionKey: {
        name: `column${index}`,
        index: index,
      },
      label: item.split("(")[0].trim(),
      types: types[index],
    };
  });

  const dropDownVariables = [];

  conditionVariables.forEach((variable) => {
    if (variable.types === valueTypes.number || variable.types === valueTypes.date) {
      // TODO: fix to helper function
      const currentType = variable.types === valueTypes.number ? "number" : "date"
      dropDownVariables.push({
        key: v4(),
        name: variable.name,
        label: "[" + variable.label + "]",
        valueType: currentType,
        nextNodeType: [FormulaTree.NODE_TYPES.Operator],
        type: FormulaTree.NODE_TYPES.Variable,
      });
    }
  });

  return {
    type: SET_CONDITION_VARIABLES,
    payload: {
      dropdownData: {
        [FormulaTree.NODE_TYPES.Variable]: dropDownVariables,
      },
      conditionVariables,
    },
  };
};

export const setShowDropdownAC = (boolValue) => {
  return {
    type: SET_SHOW_DROPDOWN,
    payload: {
      showDropdown: boolValue,
    },
  };
};

export const setNewColumnNameValueAC = (newColumnName) => {
  return {
    type: SET_COLUMN_NAME_VALUE,
    payload: {
      newColumnName,
    },
  };
};

export const deleteColumnAC = (columnName, currentTableId) => {
  return {
    type: DELETE_COLUMN,
    payload: {
      columnName,
      currentTableId
    },
  };
};

export const setFunctionValueAC = (functionValue) => {
  return {
    type: SET_FUNCTION_VALUE,
    payload: {
      functionValue,
    },
  };
};

export const setSortedValueAC = (currentSortedValue) => {
  return {
    type: SET_CURRENT_SORTED_VALUE,
    payload: {
      currentSortedValue,
    },
  };
};

export const setCursorPositionAC = (currentPosition) => {
  return {
    type: SET_CURSOR_POSITION,
    payload: {
      currentPosition,
    },
  };
};

export const setTreeAC = (currentTree) => {
  return {
    type: SET_TREE,
    payload: {
      currentTree,
    },
  };
};

export const setNodeListAC = (currentNodeList) => {
  return {
    type: SET_NODE_LIST,
    payload: {
      currentNodeList,
    },
  };
};

export const createColumnSchemeAC = (
  {
    currentTableId,
    functionValue,
    variablesForCondition,
    newColumnName,
    currentTabId,
    currentTree,
    prevColumnName = null,
  }
) => {
  const stringFunction = functionParserService.createFunctionValue(
    functionValue,
    variablesForCondition
  );
  const variables = variablesForCondition.reduce((acc, item) => {
    if (!acc[item.conditionKey.name]) {
      acc[item.conditionKey.name] = item.conditionKey.index;
    }
    return acc;
  }, {});

  return {
    type: SET_COLUMN_SCHEME,
    payload: {
      currentTableId,
      prevColumnName,
      newColumnName,
      columnSchemes: {
        [newColumnName]: {
          currentTree,
          newColumnName,
          functionValue,
          columnCondition: stringFunction,
          variables,
          currentTabId,
        }
      },
    },
  };
};


export const restConditionModalAC = () => {
  return {
    type: RESET_CONDITION_MODAL
  }
}